import { Saga } from "redux-saga";

import { aaaProgramSagas } from "./aaaProgramSagas";
import { capabilitiesSagas } from "./capabilitiesSagas";
import { crmIdXboxSagas } from "./crmIdXboxSagas";
import { crmSagas } from "./crmSagas";
import { navigationSagas } from "./navigationSagas";
import { partnerCenterSagas } from "./partnerCenterSagas";

export const partnerSagas: Saga[] = [
  capabilitiesSagas,
  crmSagas,
  crmIdXboxSagas,
  navigationSagas,
  partnerCenterSagas,
  aaaProgramSagas,
];
